@if ((currentTab$ | async) === tabs.manureOffers) {
  <app-offer-overview-table></app-offer-overview-table>
}
@if ((currentTab$ | async) === tabs.manureRequests) {
  <app-requests-overview-table></app-requests-overview-table>
}
